var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExactReportLogo = function SvgExactReportLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    "aria-hidden": "true"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#exact-report-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EFEFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E56DB",
    d: "m15 25.5-3.297-7.22L4.5 14.982l7.203-3.299L15 4.5l3.333 7.183 7.167 3.299-7.167 3.298zm0-5.424 1.72-3.518 3.512-1.576-3.512-1.576L15 9.887l-1.684 3.519-3.548 1.576 3.548 1.576z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "exact-report-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgExactReportLogo;